export enum TextFieldVariant {
    Standard = 'standard',
    Outlined = 'outlined',
    Filled = 'filled',
}
